export const worksList = [
  {
    img: '/img/work-1.png',
    images: ['https://picsum.photos/seed/1/1080/700', 'https://picsum.photos/seed/2/1080/700', 'https://picsum.photos/seed/3/1080/700'],
    title: 'Комфорт Лофт',
    text: 'Расчёт ремонта квартиры онлайн. Укажите параметры вашей квартиры, затем в конструкторе выберите планируемый дизайн.',
    fullText:
      'Разнообразный и богатый опыт дальнейшее развитие различных форм деятельности позволяет выполнять важные задания по разработке соответствующий условий активизации. Идейные соображения высшего порядка, а также консультация с широким активом позволяет выполнять важные задания по разработке модели развития.',
    path: '/comfort-loft',
  },
  {
    img: '/img/work-2.png',

    title: 'Урабаническая стилистика',
    text: 'Расчёт ремонта квартиры онлайн. Укажите параметры вашей квартиры, затем в конструкторе выберите планируемый дизайн.',
    path: '/comfort-loft',
  },
  {
    img: '/img/work-3.png',
    title: 'Комфорт Лофт',
    text: 'Расчёт ремонта квартиры онлайн. Укажите параметры вашей квартиры, затем в конструкторе выберите планируемый дизайн.',
    path: '/comfort-loft',
  },
  {
    img: '/img/work-4.png',
    title: 'Урабаническая стилистика',
    text: 'Расчёт ремонта квартиры онлайн. Укажите параметры вашей квартиры, затем в конструкторе выберите планируемый дизайн.',
    path: '/comfort-loft',
  },
];
